export default __webpack_public_path__ + "static/media/INU_nomal.0d90eb1f.png";